<jupiter-panel-container>
  <jupiter-panel-header
    header
    [panelDef]="panelDef"
    [editMode]="editMode | async"
    (startEditLayout)="onStartEditLayout()"
    (cancelEditLayout)="onCancelEditLayout()"
    (saveLayout)="onSaveLayout()"
  >
    <ng-container customActions>
      <button mat-icon-button (click)="fileInput.click()" type="button" [disabled]="isBusy | async">
        <mat-icon [svgIcon]="'publish'"></mat-icon>
      </button>
      <input
        #fileInput
        class="hidden"
        [type]="'file'"
        [accept]="allowedFormats.join(',')"
        (change)="onFileSelected($event)"
      />
    </ng-container>
    <ng-container editModeCustomActions> </ng-container>
  </jupiter-panel-header>
  <div body class="panel-gallery__form__body px-4">
    @if (model.images?.length) {
      <section class="flex flex-col">
        <gallery
          gallerize
          #photoGallery
          [items]="model | tsMutateToAny: transformToGalleryItems"
          [dots]="true"
          [thumb]="false"
          [nav]="false"
          (indexChange)="onIndexChange($event)"
        ></gallery>
        @if (!(editMode | async)) {
          <section class="action-buttons flex justify-between">
            <button mat-icon-button (click)="photoGallery.prev()" type="button" [matTooltip]="'Previous photo'">
              <mat-icon [svgIcon]="'chevron_left'"></mat-icon>
            </button>
            <button
              mat-icon-button
              type="button"
              (click)="deletePhoto()"
              [matTooltip]="'Delete active photo'"
              [disabled]="isBusy | async"
            >
              <mat-icon [svgIcon]="'delete'"></mat-icon>
            </button>
            <button mat-icon-button (click)="photoGallery.next()" type="button" [matTooltip]="'Next photo'">
              <mat-icon [svgIcon]="'chevron_right'"></mat-icon>
            </button>
          </section>
        }
      </section>
    } @else {
      <section class="flex flex-col items-center justify-center h-full">
        <mat-icon class="icon-size-40" [svgIcon]="'image'"></mat-icon>
        <p class="text-2xl text-secondary font-medium mt-4">No images found</p>
        <p class="text-sm text-secondary mt-2">Add images to this panel to display them.</p>
      </section>
    }
  </div>
</jupiter-panel-container>
